
  <nav class="d-flex flex-wrap text-center nav mt-sm-3 mt-lg-1">
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/procurement/rfq-list">{{'menu.my_rfq' | translate}}</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/procurement/rfq/my-proforma-po">{{'menu.list_proforma_po' | translate}}</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/procurement/rfq/recurring">{{'menu.recurring_rfq' | translate}}</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/procurement/rfq-history">{{'menu.history_rfq' | translate}}</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/procurement/rating/procurement-rating-list">{{'menu.review_quotation' | translate}}</a>
    </li>
  </nav>
